/** Shared by the plugin manifest (blockjam-manifest.ts) and the in-game Settings popup's version display (WP-VIS.10). */
export const BLOCKJAM_VERSION = '1.0.0';
